import EmailVerifyInputModel from '../models/EmailVerifyInput';
import * as types from '../email-verify-input-types';

export const verifyEmail = (email, isInputError) => {
    return (dispatch) => {
    dispatch(fetching());

        const emailVerifyInputModel = new EmailVerifyInputModel();
        let aborted = false;
        let verifiedUnverified = false;

        setTimeout(() => {
            if (!verifiedUnverified) {
                aborted = true;
                dispatch(failedToFetch());
                dispatch(checkEmailInputState(false));
            }
        }, 3000);

        return emailVerifyInputModel.verifyEmail(email)
            .then((res) => {
                if (!aborted) {
                    dispatch(receivedResult(res));
                    dispatch(checkEmailInputState(!res.emailVerified));
                    verifiedUnverified = true;
                }
            })
            .catch((error) => {
                if (!aborted) {
                    if (error) {
                        isInputError = true;
                    }
                    dispatch(failedToFetch(error));
                    dispatch(checkEmailInputState(isInputError));
                    verifiedUnverified = true;
                }
            });
    };
};

export const reset = () => {
    return {
        type: types.RESET
    };
};

export const emailOverride = (email) => {
    return {
        type: types.EMAIL_OVERRIDE,
        data: {email}
    };
};

export const emailChanged = (email) => {
    return {
        type: types.EMAIL_CHANGED,
        data: {email}
    }
};

export const fetching = () => {
    return {
        type: types.FETCHING,
        data: {isValidatingEmail: true}
    };
};

export const failedToFetch = (error) => {
    return {
        type: types.FAILED,
        data: { error, emailVerifyAttempted: true, isValidatingEmail: false }
    };
};

export const receivedResult = (result) => {
    return {
        type: types.RECEIVED_VERIFY_RESULT,
        data: { ...result, emailVerifyAttempted: true, isValidatingEmail: false }
    };
};

export const checkEmailInputState = (inputErrorState) => {
    return {
        type: types.CHECK_EMAIL_INPUT_STATE,
        data: {inputErrorState}
    };
};
